.fake-combo {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  border: #aaa solid 1px;
  border-radius: 5px;
  padding: 5px;
  min-width: 93%;
  background-color: #fff;
}
.fake-combo i {
  color: #888;
}
.fake-combo:hover {
  cursor: pointer;
  filter: brightness(90%);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvanRyZW1ibGF5L3NvbHV0aW9uc3RsbS50aWNrZXRpbmdzeXN0ZW0vc3JjL3RzLmludGVybmV0c2FsZS4zLjAvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvYXRvbXMiLCJzb3VyY2VzIjpbImZha2UtY29tYm8uc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQTtFQUNJO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDSTs7QUFHSjtFQUNJO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyJcbi5mYWtlLWNvbWJvIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgICBhbGlnbi1pdGVtczogYmFzZWxpbmU7XG4gICAgYm9yZGVyOiAjYWFhIHNvbGlkIDFweDtcbiAgICBib3JkZXItcmFkaXVzOiA1cHg7XG4gICAgcGFkZGluZzogNXB4O1xuICAgIG1pbi13aWR0aDogOTMlO1xuICAgIGJhY2tncm91bmQtY29sb3I6ICNmZmY7XG5cbiAgICBpIHtcbiAgICAgICAgY29sb3I6Izg4ODtcbiAgICB9XG5cbiAgICAmOmhvdmVyIHtcbiAgICAgICAgY3Vyc29yOiBwb2ludGVyO1xuICAgICAgICBmaWx0ZXI6YnJpZ2h0bmVzcyg5MCUpO1xuICAgIH1cbn0iXX0= */